<template>
  <div class="project-monitoring-page">
    <div
      v-if="projectChartData?.config && projectChartData?.data"
      class="analytics-wrapper"
    >
      <Chart
        type="chart"
        :options="projectChartData.config"
        :data="projectChartData.data"
        style="width: 100%"
      ></Chart>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Filler,
} from 'chart.js'
import moment from 'moment'
import { Chart, Bar, Scatter, Line } from 'vue-chartjs'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export default {
  data() {
    return {
      projectChartData: {
        config: null,
        data: null,
      },
    }
  },
  props: {
    projectId: Number,
  },
  components: {
    Chart,
    Bar,
    Scatter,
    Line,
  },
  async created() {
    const projectData = await this.getChartData()
    this.projectChartData = projectData
  },
  methods: {
    async getChartData() {
      let configForCurrChart = JSON.parse(JSON.stringify(analyticsConfig))
      let params = {
        query: {
          id_in: [this.projectId],
        },
        aggregation: 'Daily',
        value_types: ['Accumulative'],
        ts_from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        ts_to: moment().format('YYYY-MM-DD'),
      }
      let data = await axios.post('/api/analytics/monitorings', params)
      let dataForMainChart = data.data

      let { labels, formmatedLabels } = this.getLabels([
        params.ts_from,
        params.ts_to,
      ])

      let { dataSetsFromDB } = organizeDatasets(dataForMainChart, labels)
      if (dataSetsFromDB.length === 0) return

      let flattenDatasets = dataSetsFromDB.flat()
      flattenDatasets = flattenDatasets.filter((set) => {
        if (set?.data?.length > 0) {
          return set
        }
      })
      if (flattenDatasets.length === 0) return

      let tempScales = flattenDatasets.map((data) => {
        return {
          group: data.group,
          unit: data.unit,
        }
      })
      tempScales = removeDuplicatesScales(tempScales)
      let currentScales = createScaleObject(tempScales)
      configForCurrChart.scales = currentScales
      return {
        data: {
          labels: formmatedLabels,
          datasets: flattenDatasets,
        },
        config: configForCurrChart,
      }
    },
    getLabels(date) {
      let labels = getDatesBetween(date)
      let formmatedLabels = labels.map((label) =>
        moment(label).format('YYYY-MM-DD')
      )
      formmatedLabels = labels.map((label) => this.formatDate(label))
      return {
        labels,
        formmatedLabels,
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      const day = date.getDate()
      const month = date.toLocaleString('default', { month: 'short' })
      return `${day}. ${month}`
    },
  },
}
</script>

<style lang="scss" scoped>
.project-monitoring-page {
  height: 350px;
  background: white;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  max-height: 70%;
}
.analytics-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}
</style>
